export default class DashboardController {
  constructor(props) {
    this.prxManager = props.prxManager;
    this.coreManager = props.coreManager;
  }

  getTriageLevelClassify = async ({
    apiToken,
    divisionId
  } = {}) => {
    const [
      response,
      error,
      network
    ] = await this.prxManager.getTriageLevelClassify({
      apiToken,
      divisionId
    });
    return [response, error, network];
  };

  getDivision = async ({ isTelemed, apiToken, organization }: any = {}) => {
    const [data, error] = await this.coreManager.getDivision({ isTelemed, apiToken, organization });
    return [data, error];
  };

  getDashboard = async ({
    apiToken,
    search,
    date,
    triageLevels,
    division,
    paymentStatus,
    organization
  } = {}) => {
    const [
      response,
      error,
      network
    ] = await this.prxManager.getDashboard({
      apiToken,
      search,
      date,
      triageLevels,
      division,
      paymentStatus,
      organization
    });
    return [response, error, network];
  }

  getOfficialAccountDashboard = async ({
    apiToken,
    search,
    date,
    triageLevels,
    division,
    paymentStatus
  } = {}) => {
    const [
      response,
      error,
      network
    ] = await this.prxManager.getOfficialAccountDashboard({
      apiToken,
      search,
      date,
      triageLevels,
      division,
      paymentStatus
    });
    return [response, error, network];
  }

  getOAInviteLink = async ({
    apiToken,
    divisionId
  }) => {

    const [
      response,
      error,
      network
    ] = await this.prxManager.getOAInviteLink({
      apiToken,
      divisionId
    });
    return [response, error, network];
  }

}